import {getEventClassName, getEventShortName} from "../shared";
import useEventsForADay from "../useEventsForADay";
import {selectCalendarData, selectCurrentEmployee, selectDepartment} from "../../../features/AppStateSlice";
import {useAppSelector} from "../../hooks";
import {RREventType} from "../../types/RREventType";
import {dateToString} from "../../tools";
import {RRCalendarDayType} from "../../types/RRCalendarDayType";
import {dayTypeToString} from "../../views/calendar/CalendarNoEventsCellContent";

type MEventsCalendarCellProps = {
    day: Date;
}

const MEventsCalendarCell: React.FC<MEventsCalendarCellProps> = ({day}) => {
    const activeDerpartment = useAppSelector(selectDepartment);
    const events = useEventsForADay(day);
    const currentEmployee = useAppSelector(selectCurrentEmployee);
    const allCalendarData = useAppSelector(selectCalendarData);

    const dayAsString = dateToString(day);
    let emplItem: RRCalendarDayType | undefined;
    allCalendarData.forEach(
        cItem => {
            if (cItem.date === dayAsString) {
                cItem.items.forEach(
                    item => {
                        if (item.employeeId === currentEmployee?.id) {
                            emplItem = item;
                        }
                    }
                );
            }
        }
    );

    if (emplItem && emplItem.dayType !== "WORKDAY") {
        return (
            <>
                <h6>{day.getDate()}</h6>
                <div style={{maxWidth: "34pt", fontSize: "6.5pt"}}
                     className={"text-center bg-danger text-white"}>
                    {dayTypeToString(emplItem.dayType)}</div>
            </>
        );
    }

    return (
        <>
            <h6>{day.getDate()}</h6>
            {
                events.length > 0 && events.map(
                    event =>
                        <div key={event.id}
                             style={{maxWidth: "34pt", fontSize: "6.5pt"}}
                             className={getEventClassName(event)}>
                            {getEventShortName(event, activeDerpartment)}</div>
                )
            }
        </>
    );
};

export default MEventsCalendarCell;
